import type { BetaFeatureItem } from '../api/types';

/**
 * Включена ли бета-функция с данным кодом по реестру.
 *
 * Пока реестр не получен и для кода, которого в нём нет, функция считается выключенной —
 * не включённую явно функцию интерфейс не проявляет. Правило живёт здесь одно на все места
 * чтения состояния: и хуки одной функции, и предикат по списку, где хук не вызвать.
 */
export const isBetaFeatureEnabled = (features: BetaFeatureItem[] | undefined, code: string | undefined): boolean =>
  Boolean(features?.find((feature) => feature.code === code)?.isEnabled);

/**
 * Доступно ли то, что закрыто бета-функцией лишь иногда: маршрут, пункт меню.
 * Незаданный код означает «функцией не закрыто» — доступно всегда.
 */
export const isRouteBetaFeatureEnabled = (features: BetaFeatureItem[] | undefined, code: string | undefined): boolean =>
  !code || isBetaFeatureEnabled(features, code);
